import React, { useEffect } from 'react';

function PrivacyPage() {
    useEffect(() => {
        // Скрываем баннер куки на странице политики
        const banner = document.getElementById('cookieConsentBanner');
        if (banner) {
            banner.style.display = 'none';
        }
    }, []);

    const goHome = () => {
        window.location.href = '/';
    };

    return (
        <div className="container py-5">
            <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '50px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                maxWidth: '900px',
                margin: '0 auto'
            }}>
                <h1 style={{ fontWeight: 700, marginBottom: 30, color: '#2c3e50' }}>
                    Политика конфиденциальности
                </h1>

                <p style={{ lineHeight: 1.8, color: '#555', marginBottom: 15 }}>
                    Настоящая политика действует в отношении сайта <strong>nickproject.ru</strong>.
                </p>

                <p style={{ lineHeight: 1.8, color: '#555', marginBottom: 15 }}>
                    Наш сайт <strong>не собирает и не хранит</strong> персональные данные посетителей.
                    На сайте нет форм обратной связи, регистрации или сбора контактов.
                </p>

                <p style={{ lineHeight: 1.8, color: '#555', marginBottom: 15 }}>
                    Единственное, что мы используем — это <strong>файлы cookie</strong> для запоминания
                    вашего согласия с этим уведомлением. Эти файлы хранятся только в вашем браузере
                    и не передаются третьим лицам.
                </p>

                <p style={{ lineHeight: 1.8, color: '#555', marginBottom: 15 }}>
                    Вы можете отключить cookie в настройках браузера — это не повлияет на просмотр портфолио.
                </p>

                <p style={{ lineHeight: 1.8, color: '#555', marginBottom: 15 }}>
                    📍 г. Магнитогорск<br />
                    📞 +7 (915) 433-40-80
                </p>

                <button
                    onClick={goHome}
                    style={{
                        display: 'inline-block',
                        marginTop: 30,
                        color: '#f39c12',
                        background: 'none',
                        border: 'none',
                        textDecoration: 'none',
                        fontWeight: 600,
                        cursor: 'pointer',
                        fontSize: '1rem',
                        fontFamily: "'Montserrat', sans-serif",
                        padding: 0
                    }}
                >
                    ← Вернуться на главную
                </button>
            </div>
        </div>
    );
}

export default PrivacyPage;